cb.define(['common/common_VM.Extend.js'], function (common) {
    //String转换Int（位运算）
    var setCheckBoxEnum = function (data) {

        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }

    };

    var PM_pmc_jewelrypromotion_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            let mode = viewmodel.getParams().mode;
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');
            var user = cb.rest.AppContext.user;
            const displayMemberLevelAll = () => {
                if (viewmodel.get('bMemberLevelAll').getValue() == 3) {
                    viewmodel.get('jewelryPromotionMemberLevel').setVisible(true);
                } else {
                    viewmodel.get('jewelryPromotionMemberLevel').setVisible(false);
                }
            }
            const displayApplyStoreType = () => {
                if (viewmodel.get('iApplyStoreType').getValue() == 1) {
                    viewmodel.get('jewelryPromotionStore').setVisible(false);
                } else {
                    viewmodel.get('jewelryPromotionStore').setVisible(true);
                }
            }

            const displayPromotionMethod = () => {
                if (viewmodel.get('iPromotionMethod').getValue() == 1) {
                    viewmodel.get("jewelryPromotionItem").setColumnState("fDiscount", "bShowIt", true);
                    viewmodel.get("jewelryPromotionItem").setColumnState("fPriceBreaks", "bShowIt", false);
                    viewmodel.get("jewelryPromotionItem").setColumnState("fPrice", "bShowIt", false);
                } else if (viewmodel.get('iPromotionMethod').getValue() == 2) {
                    viewmodel.get("jewelryPromotionItem").setColumnState("fDiscount", "bShowIt", false);
                    viewmodel.get("jewelryPromotionItem").setColumnState("fPriceBreaks", "bShowIt", true);
                    viewmodel.get("jewelryPromotionItem").setColumnState("fPrice", "bShowIt", false);
                } else if (viewmodel.get('iPromotionMethod').getValue() == 3) {
                    viewmodel.get("jewelryPromotionItem").setColumnState("fDiscount", "bShowIt", false);
                    viewmodel.get("jewelryPromotionItem").setColumnState("fPriceBreaks", "bShowIt", false);
                    viewmodel.get("jewelryPromotionItem").setColumnState("fPrice", "bShowIt", true);
                }
            }

            const displayReferType = (value) => {
                var refCode = "";
                var refRetId = "";
                //1商品分类 2 商品 3 商品sku 4 商品标签
                if (value == 1) {
                    viewmodel.get("jewelryPromotionItem").setColumnState("cProductPicUrl", "bShowIt", false);
                    viewmodel.get("jewelryPromotionItem").setColumnState("fAUPrice", "bShowIt", false);
                    viewmodel.get("jewelryPromotionItem").setColumnState("skuDescription", "bShowIt", false);
                    viewmodel.get("jewelryPromotionItem").setColumnState("cProductName", "cShowCaption", "商品分类");
                    refCode = "pc_presentationclassref";
                    refRetId = '{"lProductId":"id","cProductName":"name"}';
                } else if (value == 2) {
                    viewmodel.get("jewelryPromotionItem").setColumnState("cProductPicUrl", "bShowIt", true);
                    viewmodel.get("jewelryPromotionItem").setColumnState("fAUPrice", "bShowIt", true);
                    viewmodel.get("jewelryPromotionItem").setColumnState("skuDescription", "bShowIt", false);
                    viewmodel.get("jewelryPromotionItem").setColumnState("cProductName", "cShowCaption", "商品名称");
                    refCode = "pmc_product";
                    refRetId = '{"lProductId":"id","cProductName":"cName","fAUPrice":"fMarkPrice","cProductPicUrl":"url"}';
                } else if (value == 3) {
                    viewmodel.get("jewelryPromotionItem").setColumnState("cProductPicUrl", "bShowIt", true);
                    viewmodel.get("jewelryPromotionItem").setColumnState("fAUPrice", "bShowIt", true);
                    viewmodel.get("jewelryPromotionItem").setColumnState("skuDescription", "bShowIt", true);
                    viewmodel.get("jewelryPromotionItem").setColumnState("cProductName", "cShowCaption", "商品SKU");
                    refCode = "aa_productsku";
                    refRetId = ' {"lProductId":"productskus_id","cProductName":"name","fAUPrice":"fMarkPrice","cProductPicUrl":"productUrl","skuDescription":"specs"}';
                } else if (value == 4) {
                    viewmodel.get("jewelryPromotionItem").setColumnState("cProductPicUrl", "bShowIt", false);
                    viewmodel.get("jewelryPromotionItem").setColumnState("fAUPrice", "bShowIt", false);
                    viewmodel.get("jewelryPromotionItem").setColumnState("skuDescription", "bShowIt", false);
                    viewmodel.get("jewelryPromotionItem").setColumnState("cProductName", "cShowCaption", "商品标签");
                    refCode = "pc_tagref";
                    refRetId = '{"lProductId":"id","cProductName":"name"}';
                }
                if (refCode) {
                    viewmodel.get("jewelryPromotionItem").getEditRowModel().get("cProductName").setRefCode(refCode, refRetId);
                }
            }

            const delPro = () => {
                if (viewmodel.get('jewelryPromotionItem').getData() && viewmodel.get('jewelryPromotionItem').getData().length > 0) {
                    let pricenums = viewmodel.get('jewelryPromotionItem').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('jewelryPromotionItem').deleteRows(i);
                    }
                }
            }

            viewmodel.get("bMemberLevelAll").on('afterValueChange', () => {
                displayMemberLevelAll();
            })

            viewmodel.get("iApplyStoreType").on('afterValueChange', () => {
                displayApplyStoreType();
            })

            viewmodel.get("iPromotionMethod").on('afterValueChange', () => {
                displayPromotionMethod();
            })

            viewmodel.get("iPromotionDimension").on('afterValueChange', () => {
                displayReferType(viewmodel.get('iPromotionDimension').getValue());
                delPro();
            })

            viewmodel.on('batchModifySetFields', function (args) {
                debugger
                args.forEach((item, index) => {
                    if (item.fieldName === 'cProductName' || item.fieldName === 'iSorteLimitAmount' || item.fieldName === 'iAmount') {
                        item.bCanModify = false;
                    }
                    if (viewmodel.get('iPromotionMethod').getValue() == 1) {
                        if (item.fieldName === 'fPriceBreaks' || item.fieldName === 'fPrice') {
                            item.bCanModify = false;
                        }
                    } else if (viewmodel.get('iPromotionMethod').getValue() == 2) {
                        if (item.fieldName === 'fDiscount' || item.fieldName === 'fPrice') {
                            item.bCanModify = false;
                        }
                    } else if (viewmodel.get('iPromotionMethod').getValue() == 3) {
                        if (item.fieldName === 'fDiscount' || item.fieldName === 'fPriceBreaks') {
                            item.bCanModify = false;
                        }
                    }

                })
            })

            viewmodel.on('afterLoadData', function (data) {
                displayApplyStoreType();
                displayMemberLevelAll();
                displayPromotionMethod();
                displayReferType(viewmodel.get('iPromotionDimension').getValue());
                common.displayChannel(viewmodel, 'jewelrypromotion');

                viewmodel.get("jewelryPromotionItem").getEditRowModel().get('fDiscount').setState('min', 0);
                viewmodel.get("jewelryPromotionItem").getEditRowModel().get('fDiscount').setState('max', 10);
                viewmodel.get("jewelryPromotionItem").getEditRowModel().get('fPriceBreaks').setState('min', 0);
                viewmodel.get("jewelryPromotionItem").getEditRowModel().get('fPrice').setState('min', 0);
                viewmodel.get("jewelryPromotionItem").getEditRowModel().get('iAmount').setState('min', 0);
                viewmodel.get("jewelryPromotionItem").getEditRowModel().get('iSorteLimitAmount').setState('min', 0);

            });

            //商品控制单元格是否可修改
            viewmodel.get('jewelryPromotionItem').on('rowColChange', function (data) {
                if (data.value.columnKey == 'iAmount') {
                    if (this.getCellValue(data.value.rowIndex, 'iBuyerLimitAmount') != '4') {
                        return false;
                    }
                }
            });

            viewmodel.get('jewelryPromotionItem').on('beforeBrowse', function (data) {
                //1商品分类 2 商品 3 商品sku 4 商品标签
                let type = viewmodel.get('iPromotionDimension').getValue();
                let condition = {
                    "isExtend": true,
                    simpleVOs: []
                };
                let itemList = viewmodel.get("jewelryPromotionItem").getRows();
                let exitIds = [];
                if (itemList) {
                    for (let i = 0; i < itemList.length; i++) {
                        if (itemList[i].lProductId && itemList[i].lProductId != '') {
                            exitIds.push(itemList[i].lProductId);
                        }
                    }
                    condition.simpleVOs.push({
                        field: 'id',
                        op: 'nin',
                        value1: exitIds
                    });
                }
                if (type == 2 || type == 3) {
                    let fieldName = (type == 2 ? "" : 'productId.');
                    if (user && user.iShopId) {
                        condition.simpleVOs.push({
                            field: fieldName + 'productApplyRange.shopId',
                            op: 'eq',
                            value1: user.iShopId
                        });
                    } else {
                        condition.simpleVOs.push({
                            field: fieldName + 'productApplyRange.isCreator',
                            op: 'eq',
                            value1: 1
                        });
                    }
                    condition.simpleVOs.push({
                        field: fieldName + 'saleStyle',
                        op: 'eq',
                        value1: 1
                    });
                }
                data.context.setFilter(condition);
            })

            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                debugger
                delPro();
            })

            //保存前数据处理
            viewmodel.on('beforeSave', function (data) {

                var obj = JSON.parse(data.data.data);

                if (this.get('bMemberLevelAll').getValue() == '3' && this.get('jewelryPromotionMemberLevel').getShowValue() == '') {
                    cb.utils.alert('指定会员不可为空', 'warning');
                    return false;
                } else if (this.get('bMemberLevelAll').getValue() != '3') {
                    obj.jewelryPromotionMemberLevel = [];
                }

                if (this.get('iApplyStoreType').getValue() != '1' && this.get('jewelryPromotionStore').getShowValue() == '') {
                    cb.utils.alert('指定门店不可为空', 'warning');
                    return false;
                } else if (this.get('iApplyStoreType').getValue() == '1') {
                    obj.jewelryPromotionStore = [];
                }
                // if (mode == 'add') {
                //     if (viewmodel.get('cBeginTime').getValue() <= nowDates) {
                //         cb.utils.alert('开始时间大于当前时间', 'warning');
                //         return false;
                //     }
                // }
                if (viewmodel.get('jewelryPromotionItem').getRows() == '') {
                    cb.utils.alert('所选商品不能为空', 'warning');
                    return false;
                }

                if (this.get('cBeginTime').getValue() >= this.get('cEndTime').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }
                for (let i = 0; i < viewmodel.get('jewelryPromotionItem').getRows().length; i++) {
                    if (viewmodel.get('iPromotionMethod').getValue() == '1') {
                        if (!viewmodel.get('jewelryPromotionItem').getCellValue(i, 'fDiscount') || viewmodel.get('jewelryPromotionItem').getCellValue(i, 'fDiscount') == 0) {
                            cb.utils.alert('请输入第' + (i + 1) + '行折扣', 'warning');
                            return false;
                        }
                    } else if (viewmodel.get('iPromotionMethod').getValue() == '2') {
                        if (viewmodel.get('iPromotionDimension').getValue() == '2' || viewmodel.get('iPromotionDimension').getValue() == '3') {
                            if (!viewmodel.get('jewelryPromotionItem').getCellValue(i, 'fPriceBreaks') || viewmodel.get('jewelryPromotionItem').getCellValue(i, 'fPriceBreaks') == 0) {
                                cb.utils.alert('请输入第' + (i + 1) + '行减价', 'warning');
                                return false;
                            } else if (viewmodel.get('jewelryPromotionItem').getCellValue(i, 'fAUPrice') <
                                viewmodel.get('jewelryPromotionItem').getCellValue(i, 'fPriceBreaks')) {
                                cb.utils.alert('第' + (i + 1) + '行商品减价不能大于原价', 'warning');
                                return false;
                            }
                        }
                    } else if (viewmodel.get('iPromotionMethod').getValue() == '3') {
                        if (!viewmodel.get('jewelryPromotionItem').getCellValue(i, 'fPrice') || viewmodel.get('jewelryPromotionItem').getCellValue(i, 'fPrice') == 0) {
                            cb.utils.alert('请输入第' + (i + 1) + '行一口价', 'warning');
                            return false;
                        }
                    }
                    if (viewmodel.get('jewelryPromotionItem').getCellValue(i, 'iBuyerLimitAmount') == 4) {
                        if (!viewmodel.get('jewelryPromotionItem').getCellValue(i, 'iAmount') || viewmodel.get('jewelryPromotionItem').getCellValue(i, 'iAmount') == 0) {
                            cb.utils.alert('请输入第' + (i + 1) + '行限购数量', 'warning');
                            return false;
                        }
                    }

                }
                data.data.data = JSON.stringify(obj);
            });
        }
    };
    try {
        module.exports = PM_pmc_jewelrypromotion_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_jewelrypromotion_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_jewelrypromotion_VM.Extend.js